import { Typography as AntTypography } from 'antd';
import classNames from 'classnames';
import React, { memo } from 'react';

type CopyableTextProps = {
  children: string | number;
  /** Default: @dark-cool-grey. */
  customColor?: 'inherit' | 'internalAdmin';
};

function CopyableText({ children, customColor }: CopyableTextProps): JSX.Element {
  const className = classNames('body-copy', {
    'internal-admin': customColor === 'internalAdmin'
  });
  const style = customColor === 'inherit' ? { color: 'inherit' as const } : undefined;

  return (
    <AntTypography.Text copyable className={className} style={style}>
      {children}
    </AntTypography.Text>
  );
}

export default memo(CopyableText);
export type { CopyableTextProps };
